import { render, staticRenderFns } from "./coinTypeOptions.vue?vue&type=template&id=ed1ed296&"
import script from "./coinTypeOptions.vue?vue&type=script&lang=js&"
export * from "./coinTypeOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed1ed296')) {
      api.createRecord('ed1ed296', component.options)
    } else {
      api.reload('ed1ed296', component.options)
    }
    module.hot.accept("./coinTypeOptions.vue?vue&type=template&id=ed1ed296&", function () {
      api.rerender('ed1ed296', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/serverList/coinTypeOptions.vue"
export default component.exports